import { createStore, applyMiddleware, combineReducers } from "redux";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import ReduxThunk from "redux-thunk";

import global from "./reducers/global";
import auth from "./reducers/auth";
import orderFlow from "./reducers/orderFlow";
import cart from "./reducers/cart";

export const root = combineReducers({
  global,
  auth,
  orderFlow,
  cart,
});

export const store = createStore(root, applyMiddleware(ReduxThunk));

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
